export interface MusteriYorumu {
  id: string;
  isim: string;
  sehir: string;
  hizmet: string;
  yorum: string;
  puan: number;
  tarih: string;
  avatar: string;
  onceGorsel?: string;
  sonraGorsel?: string;
}

export const musteriYorumlari: MusteriYorumu[] = [
  {
    id: "y1",
    isim: "Selin Kaya",
    sehir: "İstanbul",
    hizmet: "Hydrafacial Bakım",
    yorum: "Hayatımda denediğim en iyi cilt bakımıydı. Seanstan çıktığımda cildim o kadar parlak ve nemli görünüyordu ki herkes ne yaptığımı sordu. Elora ekibi gerçekten profesyonel ve ilgili. Kesinlikle tavsiye ediyorum!",
    puan: 5,
    tarih: "Mart 2026",
    avatar: "https://readdy.ai/api/search-image?query=beautiful%20young%20turkish%20woman%20smiling%20warmly%20natural%20makeup%20soft%20cream%20background%20professional%20portrait%20photography%20elegant%20feminine&width=120&height=120&seq=yor001&orientation=squarish",
  },
  {
    id: "y2",
    isim: "Ayşe Mercan",
    sehir: "Ankara",
    hizmet: "Lazer Epilasyon",
    yorum: "6 seans sonunda gerçekten kalıcı sonuç aldım. Artık tıraş stresi yok, her gün pürüzsüz hissediyorum. Uygulama sırasında hiç ağrı hissetmedim, personel çok nazik ve anlayışlıydı.",
    puan: 5,
    tarih: "Şubat 2026",
    avatar: "https://readdy.ai/api/search-image?query=elegant%20turkish%20woman%2030s%20smiling%20portrait%20soft%20beige%20background%20natural%20beauty%20professional%20headshot%20warm%20lighting%20feminine&width=120&height=120&seq=yor002&orientation=squarish",
  },
  {
    id: "y3",
    isim: "Zeynep Arslan",
    sehir: "İzmir",
    hizmet: "Dudak Renklendirme",
    yorum: "Artık sabahları makyaj yapmadan çıkabiliyorum. Dudaklarım her zaman bakımlı ve güzel görünüyor. Renk seçiminde çok yardımcı oldular, tam istediğim doğal tonu bulduk. Çok memnunum!",
    puan: 5,
    tarih: "Ocak 2026",
    avatar: "https://readdy.ai/api/search-image?query=young%20stylish%20turkish%20woman%20smiling%20portrait%20light%20background%20natural%20glow%20professional%20photography%20warm%20tones%20feminine%20beauty&width=120&height=120&seq=yor003&orientation=squarish",
  },
  {
    id: "y4",
    isim: "Fatma Demir",
    sehir: "Bursa",
    hizmet: "G5 Sıkılaşma",
    yorum: "10 seans sonunda bacaklarımdaki selülit görünümü inanılmaz azaldı. Kendime olan güvenim arttı, yazlık kıyafetlerimi çok daha rahat giyiyorum. Elora Beauty Lounge'u herkese tavsiye ederim.",
    puan: 5,
    tarih: "Aralık 2025",
    avatar: "https://readdy.ai/api/search-image?query=mature%20turkish%20woman%2040s%20smiling%20portrait%20soft%20background%20professional%20headshot%20warm%20cream%20tones%20elegant%20natural%20beauty&width=120&height=120&seq=yor004&orientation=squarish",
  },
  {
    id: "y5",
    isim: "Merve Toprak",
    sehir: "İstanbul",
    hizmet: "Cilt Yenileme Paketi",
    yorum: "İlk seanstan sonra cildimde inanılmaz bir fark hissettim. Arkadaşlarım yaşımı 5 yıl küçük tahmin etmeye başladı! Ekip çok profesyonel, ortam çok temiz ve lüks. Fiyat-performans açısından da mükemmel.",
    puan: 5,
    tarih: "Kasım 2025",
    avatar: "https://readdy.ai/api/search-image?query=beautiful%20turkish%20woman%2035s%20glowing%20skin%20smiling%20portrait%20cream%20background%20professional%20photography%20natural%20makeup%20warm%20light%20feminine&width=120&height=120&seq=yor005&orientation=squarish",
  },
  {
    id: "y6",
    isim: "Neslihan Çelik",
    sehir: "Antalya",
    hizmet: "Hydrafacial Bakım",
    yorum: "Düğünümden önce Hydrafacial yaptırdım ve sonuçtan çok memnun kaldım. Makyajım çok daha güzel oturdu, cildim pırıl pırıl görünüyordu. Elora ekibine teşekkürler, harika bir deneyimdi!",
    puan: 5,
    tarih: "Ekim 2025",
    avatar: "https://readdy.ai/api/search-image?query=young%20elegant%20turkish%20bride%20woman%20smiling%20portrait%20soft%20white%20background%20professional%20headshot%20glowing%20skin%20warm%20tones%20feminine%20beauty&width=120&height=120&seq=yor006&orientation=squarish",
  },
];
